module.exports = __webpack_public_path__ + "static/media/b3.16e2d960.png";